import React from 'react'
// libs
import styled from 'styled-components'
// components
import { Avatar } from 'components/UI'
// types
import { components, OptionProps } from 'react-select'

const OptionWrapper = styled.div<{ isSelected: boolean; isFocused: boolean }>`
  cursor: pointer;
  display: flex;
  padding-left: 16px;
  align-items: center;
  margin-bottom: 4px;
  gap: 12px;

  .MuiAvatar-root {
    height: 34px;
    width: 34px;
    font-size: 14px;
  }

  > div:last-child {
    margin: 0;
    padding-left: 0;
  }
`

export const CustomOption = (props: OptionProps<any>) => {
  const { data, isFocused, isSelected } = props

  const showAvatar = ['USER', 'POSITION'].includes(data?.entity)

  return (
    <components.Option {...props}>
      <OptionWrapper isSelected={isSelected} isFocused={isFocused}>
        {showAvatar && <Avatar user={data} />}
        {props.children}
      </OptionWrapper>
    </components.Option>
  )
}
